module.exports = __webpack_public_path__ + "img/default_place.954dbca.jpg";